export default function lightSwitch() {
  const setMode = (mode) => {
    if (!mode) {
      return;
    }
    document.body.parentElement?.classList.remove('light')
    document.body.parentElement?.classList.remove('dark')
    document.body.parentElement?.classList.add(mode)
    localStorage.setItem('colorScheme', mode)
  }

  const handleMediaChange = (value) => {
    if (value) {
      setMode('dark')
    } else {
      setMode('light')
    }
  }

  const mm = window.matchMedia('(prefers-color-scheme: dark)')
  mm.addEventListener('change', (e) => handleMediaChange(e.matches))

  const defaultValue = localStorage.getItem('colorScheme')
  if (defaultValue) {
    setMode(defaultValue)
  }

  const control = document.querySelector("*[data-control='lightSwitch']")
  if (control) {
    control.addEventListener('click', function () {
      const currentMode = document.body.parentElement?.classList.contains('dark') ? 'dark' : 'light'
      const newMode = currentMode === 'dark' ? 'light' : 'dark'
      setMode(newMode)
    })
  }
}
